import { render } from "./ActivityData.vue?vue&type=template&id=ef3b8c16&scoped=true"
import script from "./ActivityData.vue?vue&type=script&lang=js"
export * from "./ActivityData.vue?vue&type=script&lang=js"

import "./ActivityData.vue?vue&type=style&index=0&id=ef3b8c16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef3b8c16"]])

export default __exports__